import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, Pressable, Text, View } from 'react-native';
import { colors, typography } from '../../components/crop-circle/tokens';
import EmailCodeLogin from './emailCodeLogin';
import { LoginProps } from './props';
import SmsCodeLogin from './smsCodeLogin';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

const enum LoginStrategy {
  SMS = 'SMS',
  Email = 'EMAIL',
}

export const CodeLogin = (props: LoginProps) => {
  const { t } = useTranslation();
  const [loginStrategy, setLoginStrategy] = useState(
    props.initialEmail ? LoginStrategy.Email : LoginStrategy.SMS
  );

  const toggleStrategy = () =>
    setLoginStrategy(
      loginStrategy === LoginStrategy.SMS
        ? LoginStrategy.Email
        : LoginStrategy.SMS
    );

  const toggleAction =
    loginStrategy === LoginStrategy.SMS
      ? t('login.toggleEmail')
      : t('login.togglePhone');

  return (
    <View style={styles.container}>
      {Platform.OS === 'web' && (
        <View style={styles.headlineSection}>
          <Text style={styles.displayTitle}>{t('login.welcome')}</Text>
          <Text style={styles.displaySubtitle}>
            {t('login.signUpToContinue')}
          </Text>
        </View>
      )}

      <View style={styles.formContent}>
        {loginStrategy === LoginStrategy.SMS && <SmsCodeLogin {...props} />}
        {loginStrategy === LoginStrategy.Email && <EmailCodeLogin {...props} />}
      </View>

      <View style={styles.orToggle}>
        <Pressable onPress={toggleStrategy}>
          <Text style={styles.toggleText}>
            {t('login.orUsePrefix')}{' '}
            <Text style={styles.toggleActionText}>{toggleAction}</Text>
          </Text>
        </Pressable>
      </View>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    alignSelf: 'stretch',
  },
  headlineSection: {
    alignItems: 'center',
    gap: 8,
    marginBottom: 40,
    alignSelf: 'stretch',
  },
  displayTitle: {
    ...typography.display.largeEmphasised,
    textAlign: 'center',
    color: role.textStrong,
  },
  displaySubtitle: {
    ...typography.body.small,
    textAlign: 'center',
    color: role.textStrong,
  },
  formContent: {
    alignSelf: 'stretch',
    gap: 12,
  },
  orToggle: {
    alignItems: 'center',
    marginTop: 24,
  },
  toggleText: {
    fontSize: 16,
    fontWeight: '400',
    color: role.textSoft,
    textAlign: 'center',
  },
  toggleActionText: {
    textDecorationLine: 'underline',
  },
}));
